/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isArray } from 'lodash';
import cns from 'classnames';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';
import ChooseManySlideOptions from './ChooseManySlideOptions';
import PreText from './PreText';
import PostText from './PostText';
import { RuntimeContext } from '../../../../common/RuntimeContext';

export class ChooseManySlide extends Component {
    static propTypes = {
        canMoveToNext: PropTypes.func,
        completedData: PropTypes.shape({
            data: PropTypes.array
        }),
        content: PropTypes.shape({
            options: PropTypes.array,
            description: PropTypes.string,
            displayType: PropTypes.string,
            includeChoiceLabels: PropTypes.bool,
            otherTextEnabled: PropTypes.bool
        }),
        currentUser: PropTypes.object,
        hideBookmark: PropTypes.bool,
        isRequired: PropTypes.bool,
        isWelcomeWorkspace: PropTypes.bool,
        postText: PropTypes.string,
        preText: PropTypes.string,
        name: PropTypes.string,
        nextSectionName: PropTypes.string,
        onChange: PropTypes.func,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        sendWorkspaceSegementEvent: PropTypes.func,
        userResponses: PropTypes.object,
        isRefSheet: PropTypes.bool,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        let parsedSelectChoice = props.completedData.data ? props.completedData.data : [];

        if (!isArray(parsedSelectChoice)) {
            parsedSelectChoice = [parsedSelectChoice];
        }

        this.state = {
            selectChoice: parsedSelectChoice
        };
    }

    UNSAFE_componentWillMount() {
        const { canMoveToNext, completedData = {}, isRequired = false } = this.props;
        canMoveToNext(!isEmpty(completedData) || !isRequired);
    }

    componentDidMount() {
        const {
            onChange,
            completedData = {},
            isRequired = false,
            sectionItemId,
            name,
            userResponses,
            canMoveToNext
        } = this.props;

        if (userResponses && userResponses?.byParentId[sectionItemId]) {
            this.setState({ selectChoice: userResponses?.byParentId[sectionItemId].answer.map((choice) => choice.id) });
            canMoveToNext(true);
        }

        if (!isRequired && isEmpty(completedData)) {
            const isCompleted = true;
            const isAnswered = false;
            if (onChange) {
                onChange(null, isCompleted, isAnswered);
            }
        }
    }

    handleOptionSelect = (event, choice, isOther) => {
        const { isRequired, canMoveToNext, onChange } = this.props;
        const choiceOptions = [...this.state.selectChoice];

        let indexChoice = -1;
        for (let i = 0; i < choiceOptions.length; i += 1) {
            if (choiceOptions[i].includes(choice)) {
                indexChoice = i;
            }
        }

        // if choice exist in choiceOptions, remove it..if it doesnt exist, add it
        if (indexChoice !== -1) {
            choiceOptions.splice(indexChoice, 1);
        } else {
            choiceOptions.push(choice);
        }

        this.setState({
            selectChoice: choiceOptions
        });

        if (onChange) {
            onChange(choiceOptions, true, Boolean(choiceOptions));
            if (!isOther) {
                canMoveToNext(true);
            }
        }

        if (choiceOptions.length === 0 && isRequired) {
            canMoveToNext(false);
        }
    };

    onOtherOptionChange = (event, choice) => {
        const { onChange, canMoveToNext } = this.props;
        const choiceOptions = [...this.state.selectChoice];
        const { value } = event.target;
        let addOption = true;
        for (let i = 0; i < choiceOptions.length; i += 1) {
            if (choiceOptions[i].includes(choice)) {
                choiceOptions[i] = `${choice}::::${value || ''}`;
                addOption = false;
            }
        }
        if (addOption) {
            choiceOptions.push(`${choice}::::${value || ''}`);
        }

        this.setState({
            selectChoice: choiceOptions
        });
        if (onChange) {
            onChange(choiceOptions, true, Boolean(choiceOptions));
            if (value) {
                canMoveToNext(true);
            } else {
                canMoveToNext(false);
            }
        }
    };

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            content: { displayType, options = [], description = '', includeChoiceLabels, otherTextEnabled },
            sectionId,
            sectionItemId,
            hideBookmark,
            completedData,
            isWelcomeWorkspace,
            sendWorkspaceSegementEvent,
            postText,
            preText,
            isRefSheet = false,
        } = this.props;
        const isImageType = displayType === 'image';
        return (
            <div className={'chooseSlide'}>
                <PreText text={preText} />
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={cns('chooseSlide-options', 'playerContent')}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                        sendSegementEvent={sendWorkspaceSegementEvent}
                    />
                    <div className={cns('options', { 'chooseSlide-options-images': isImageType })}>
                        <ChooseManySlideOptions
                            otherTextEnabled={otherTextEnabled}
                            displayType={displayType}
                            includeChoiceLabels={includeChoiceLabels}
                            handleOptionSelect={this.handleOptionSelect}
                            selectChoice={this.state.selectChoice}
                            options={options}
                            isWelcomeWorkspace={isWelcomeWorkspace}
                            onOtherOptionChange={this.onOtherOptionChange}
                            completedData={completedData}
                            sendSegementEvent={sendWorkspaceSegementEvent}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                    </div>
                </div>
                <PostText text={postText} />
            </div>
        );
    }
}

export default TrackPlayerSlideComponent(ChooseManySlide);
